import HTTP from '../HTTPApiGeo';

const BASE_URL = 'https://geo.api.gouv.fr/communes';
const params = {
  fields: 'nom,code,codesPostaux,codeDepartement,codeRegion,population',
  format: 'json',
  geometry: 'centre',
};

/*
 * https://api.gouv.fr/api/api-geo.html
 * https://geo.api.gouv.fr/docs/communes
 */

export async function browseCommunes(baseCommune) {
  try {
    const query = Object.assign({ nom: baseCommune }, params);
    const response = await HTTP.get(BASE_URL, { params: query });
    return response;
  } catch (e) {
    throw e;
  }
}

export function nothing() {
}



// WEBPACK FOOTER //
// ./src/api/geoGouvFr/index.js